
import { Vue, Component, Prop } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import { isFeatureEnabled } from '../../helpers/feature-flag';

@Component
export default class FeatureFlagWrapper extends Vue {
  @Prop({ required: false }) feature!: string;

  @Prop({ required: false, default: false }) defaultOn!: boolean;

  private isOn: boolean | undefined = this.defaultOn;

  async mounted() {
    if (!this.feature) return;

    this.isOn = await isFeatureEnabled(this.feature);
  }

  render(h: CreateElement): VNode {
    const slots = this.isOn ? this.$slots.featureOn : this.$slots.featureOff;
    return slots && slots.length ? slots[0] : h();
  }
}
